<div class="section block">
  <div class="account__card inner-block">
    <h1>Intäktsfiler</h1>

    <table class="table table--woo table--hover table--info centered override-bootstrap">
      <thead >
        <th>År</th>
        <th>Månad</th>
        <th>Ekonomisystem</th>
        <th>Ladda ner</th>
        <th>Skicka</th>
        <th>Skickad</th>
      </thead>
      <tbody>
        @for (report of availableReports(); track $index) {
          <tr>
              <td>{{ report.year }}</td>
              <td>{{ report.month }}</td>
            <td>
              <span>{{ clientNameForReport(report) }}</span>
            </td>
            <td>
              @if (hasRevenueFile(report)) {
                <span>
                  <button (click)="downloadXlsx(report)" class="link padding-left--none margin-left--none">Excel</button>
                  <button (click)="downloadXml(report)" class="link padding-left--none margin-left--none">XML</button>
                </span>
              } @else {
                <span>-</span>
              }
            </td>
            <td>
              <span>
                <button (click)="sendToService(report)" class="button margin-left--none" [disabled]="isSendDisabled(report)">
                  <span class="icon-ios margin-right--1x"></span> Skicka till {{ clientNameForReport(report) }}
                </button>
              </span>
            </td>
            <td>
              <span>
                @if(report.sent_to_erp_at) {
                  <span>{{ report.sent_to_erp_at | date }} ({{report.sent_to_erp_by.first_name}} {{report.sent_to_erp_by.last_name}})</span>
                } @else if (report.sent_to_telia_at) {
                  <span>{{ report.sent_to_telia_at | date }} ({{report.sent_to_telia_by.first_name}} {{report.sent_to_telia_by.last_name}})</span>
                }
                @else {
                  <span>-</span>
                }
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>